module.exports = __webpack_public_path__ + "static/media/Smatsa-report-2.7995de8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sart/Smatsa-report-2.jpg
// module id = 442
// module chunks = 0